import AddIcon from '@mui/icons-material/Add';
import { IconButton } from '@mui/material';
import { handleClickWeedTimeSlotThunk } from '@common-reducers/CalendarThunks';
import { useAppDispatch } from '@common-reducers/hooks/store.hook';
import moment from 'moment';
import React, { memo, useMemo, useCallback } from 'react';
import './calendar-custom.css';
// Note: calendar-custom.css is also imported in css-modules-entry.js for shadow DOM injection
import classes from "./message-calendar.module.scss";

interface CustomDayBackgroundProps {
    children?: React.ReactNode;
    date: Date;
}

export const CustomDayBackground = memo(({ children, date }: CustomDayBackgroundProps) => {
    const dispatch = useAppDispatch();

    // Memoize the children analysis to avoid recalculating on every render
    const hasNestedChildrenWithoutExcludedClass = useMemo(() => {
        return React.Children.toArray(children).some(child =>
            React.isValidElement(child) &&
            child.props &&
            child.props.children &&
            child.props.children !== undefined
        );
    }, [children]);

    // Memoize the half hour calculation
    const isHalfHour = useMemo(() => moment(date).minutes() === 30, [date]);

    // Memoize the click handler
    const handleClick = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
        dispatch(handleClickWeedTimeSlotThunk({ event, date }));
    }, [dispatch, date]);

    return (
        <div className={classes.week_view_time_slot_wrapper} style={{
            position: 'relative',
            width: '100%',
            height: '20px',
            display: 'flex',
            justifyContent: 'flex-end',
            opacity: !hasNestedChildrenWithoutExcludedClass ? 1 : undefined,
            zIndex: 8,
        }} onClick={handleClick}>
            {children}
            {!hasNestedChildrenWithoutExcludedClass &&
                <IconButton className={classes.addDayButton} sx={{
                    marginInlineStart: '4px !important',
                    marginInlineEnd: '0px !important',
                    marginBottom: '2px !important',
                    marginTop: isHalfHour ? '0px !important' : '2px !important',
                }}>
                    <AddIcon id={date as any} sx={{ width: "16px" }} />
                </IconButton>
            }
        </div>
    );
});
